var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashedCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127.988,
    height: 127.984,
    viewBox: "0 0 127.988 127.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22588",
    "data-name": "Group 22588",
    transform: "translate(-1341.016 -410.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22580",
    "data-name": "Group 22580",
    transform: "translate(-189.316 165.408)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22513",
    "data-name": "Group 22513",
    transform: "translate(1571.332 245.341)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29034",
    "data-name": "Path 29034",
    d: "M8.312,5.674h.01v0h0l.09.223h0l.253.618.383.936h0l.479,1.171.543,1.331h0l.577,1.408.575,1.41h0L11.77,14.1l.479,1.171h0l.381.934h0l.255.62h0l.09.225h0l1.365-.5h0l1.375-.457h0l1.389-.417h0l1.4-.377h0l1.409-.339h0l1.415-.3h0l1.426-.261h0l1.431-.219h0l1.44-.178h0l1.441-.138h0l1.45-.1h0l1.449-.058h0V1.429h0l-1.85.064h0l-1.846.118-1.84.17h0l-1.834.225h0l-1.824.275h0l-1.816.329h0l-1.8.381h0l-1.794.433h0L13.57,3.91,11.8,4.447l-1.752.587h0Z",
    transform: "translate(-8.312 -1.429)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29035",
    "data-name": "Path 29035",
    d: "M8.329,1.444Z",
    transform: "translate(-4.839 1.573)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29036",
    "data-name": "Path 29036",
    d: "M8.338,1.442Z",
    transform: "translate(-3.08 1.039)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29037",
    "data-name": "Path 29037",
    d: "M8.4,1.43Z",
    transform: "translate(9.553 -1.248)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22514",
    "data-name": "Group 22514",
    transform: "translate(1550.027 250.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29038",
    "data-name": "Path 29038",
    d: "M8.206,13.989h0l.171.17.473.473.714.714h0l.894.894,1.016,1.017h0l1.077,1.075,1.074,1.077,1.017,1.015h0l.894.9.714.714h0l.643.644h0l1.1-1.011h0l1.123-.978h0l1.149-.944h0l1.175-.91h0l1.2-.876h0l1.225-.84v0l1.247-.8h0l1.273-.77h0l1.293-.734h0l1.315-.7h0l1.335-.658h0l1.355-.622h0l-.092-.223-.253-.62h0l-.383-.934-.479-1.173h0l-.543-1.329-.577-1.41h0l-.575-1.41-.543-1.329h0l-.479-1.171L27.371,2.3h0l-.253-.618-.092-.225h0L25.3,2.238h0l-1.7.832-1.676.882h0l-1.65.93h0l-1.62.978h0l-1.59,1.025h0L15.5,7.958h0L13.972,9.075h0l-1.494,1.163-1.46,1.207h0L9.593,12.7h0Z",
    transform: "translate(-8.206 -1.456)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29039",
    "data-name": "Path 29039",
    d: "M8.227,1.5Z",
    transform: "translate(-3.955 7.283)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29040",
    "data-name": "Path 29040",
    d: "M8.283,1.464Z",
    transform: "translate(7.106 0.15)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29041",
    "data-name": "Path 29041",
    d: "M8.207,1.519Z",
    transform: "translate(-8.036 11.185)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22515",
    "data-name": "Group 22515",
    transform: "translate(1535.602 265.038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29042",
    "data-name": "Path 29042",
    d: "M8.134,20.347h0l.224.092.618.253h0l.936.383,1.173.479,1.329.543h0l1.409.577,1.409.575,1.329.543h0L19.513,25h0l.622-1.355h0l.66-1.335h0l.7-1.315h0l.734-1.293h0l.77-1.271h0l.806-1.249h0l.84-1.223h0l.876-1.2h0l.91-1.175h0l.944-1.149h0l.976-1.123h0l1.01-1.095h0l-.17-.17h0l-.473-.473L28,8.858,27.1,7.964h0L26.088,6.947h0L25.012,5.871,23.935,4.8,22.921,3.779h0l-.9-.894-.714-.714h0L20.84,1.7l-.172-.17h0L19.374,2.915h0L18.124,4.341h0L16.917,5.8,15.754,7.294h0L14.635,8.822h0l-1.07,1.558h0l-1.027,1.59h0l-.978,1.62h0l-.93,1.65h0l-.882,1.676h0l-.832,1.7h0l-.782,1.728Z",
    transform: "translate(-8.134 -1.528)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29043",
    "data-name": "Path 29043",
    d: "M8.178,1.549Z",
    transform: "translate(0.605 2.724)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29044",
    "data-name": "Path 29044",
    d: "M8.108,23.282H20.4l.054-1.454h0l.1-1.448h0l.138-1.444h0l.176-1.44h0l.219-1.432h0l.259-1.424h0l.3-1.418h0l.339-1.408h0l.377-1.4h0l.417-1.39h0l.457-1.377h0l.5-1.365h0l-.224-.092-.62-.253-.934-.383L20.78,5.079h0l-1.329-.543h0L18.041,3.96h0l-1.409-.577h0L15.3,2.839,14.13,2.36,13.2,1.977h0l-.619-.253-.224-.09h0l-.64,1.736h0l-.587,1.752h0l-.537,1.768h0L10.1,8.674h0l-.433,1.795h0l-.381,1.807L8.96,14.091h0l-.277,1.825h0L8.46,17.748h0l-.172,1.841-.116,1.845h0Z",
    transform: "translate(1522.225 284.705)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22516",
    "data-name": "Group 22516",
    transform: "translate(1530.332 310.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29045",
    "data-name": "Path 29045",
    d: "M8.107,1.755h0l.064,1.851h0L8.29,5.453l.17,1.839.223,1.835h0l.277,1.825h0l.329,1.817h0l.381,1.8.433,1.795.485,1.78h0l.537,1.768h0l.587,1.752h0l.636,1.722h0v0h0l0,0h0v0h0l.008.008h0l.215-.1h0l.619-.253.934-.381,1.173-.481h0l1.329-.543,1.409-.575,1.409-.575h0l1.329-.545,1.173-.479.936-.381h0l.618-.255.224-.09h0l-.493-1.365h0L22.77,16h0l-.417-1.387h0l-.377-1.4h0l-.339-1.408h0l-.3-1.418h0L21.08,8.965h0l-.219-1.432h0L20.683,6.1h0l-.138-1.444h0l-.1-1.448h0l-.056-1.45H8.107Z",
    transform: "translate(-8.107 -1.755)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29046",
    "data-name": "Path 29046",
    d: "M8.117,1.828Z",
    transform: "translate(-6.123 12.783)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29047",
    "data-name": "Path 29047",
    d: "M8.115,1.819Z",
    transform: "translate(-6.554 10.997)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29048",
    "data-name": "Path 29048",
    d: "M8.109,1.783Z",
    transform: "translate(-7.756 3.753)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29049",
    "data-name": "Path 29049",
    d: "M8.108,1.774Z",
    transform: "translate(-7.926 1.924)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29050",
    "data-name": "Path 29050",
    d: "M8.134,6.5h0l.782,1.728h0l.834,1.7h0l.88,1.676h0l.93,1.648h0l.978,1.62h0l1.027,1.59h0l1.07,1.56h0l1.119,1.526h0l1.163,1.5h0l1.207,1.46h0l1.251,1.424h0l1.293,1.39h0v-.01h0v0h0l.17-.17.471-.471.713-.714.9-.9h0l1.016-1.015,1.074-1.077L26.088,19.9h0L27.1,18.879h0L28,17.985l.714-.714.473-.473h0l.17-.17h0l-1.01-1.093h0l-.976-1.121h0l-.946-1.147h0l-.91-1.175h0l-.876-1.2h0L23.795,9.67h0l-.806-1.249h0l-.77-1.271h0l-.734-1.293h0l-.7-1.313h0l-.657-1.335h0l-.619-1.355h0l-.225.092-.619.253h0l-.934.381-1.173.479L15.233,3.6h0l-1.409.575-1.409.575L11.085,5.3h0l-1.173.479-.936.381h0l-.618.255-.225.09Z",
    transform: "translate(1527.451 328.304)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29051",
    "data-name": "Path 29051",
    d: "M8.206,10.623h0l1.387,1.293h0l1.426,1.251h0l1.459,1.207,1.494,1.163h0L15.5,16.655h0l1.56,1.073h0l1.59,1.025h0l1.62.978h0l1.65.93h0l1.676.88,1.7.832h0l1.73.784h0l.092-.225h0l.253-.62.381-.934.481-1.173h0l.543-1.329h0l.575-1.41.577-1.408h0l.543-1.331.479-1.171h0l.383-.936L31.587,12h0l.092-.225h0l-1.355-.622h0l-1.335-.66h0l-1.315-.7h0l-1.3-.734h0L25.108,8.3h0l-1.247-.806h0l-1.225-.84h0l-1.2-.876h0l-1.175-.91h0l-1.149-.942h0l-1.123-.978h0l-1.1-1.009h0l-.17.17-.473.473h0l-.714.714h0l-.894.894L13.625,5.2,12.55,6.279,11.474,7.355h0L10.457,8.37l-.894.9h0l-.714.714-.473.471h0l-.17.172Z",
    transform: "translate(1541.803 344.906)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22517",
    "data-name": "Group 22517",
    transform: "translate(1571.332 357.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29052",
    "data-name": "Path 29052",
    d: "M8.312,13.366h0l1.738.64L11.8,14.6l1.77.535h0l1.782.485h0l1.794.433h0l1.806.381h0l1.816.329h0l1.826.277,1.832.225,1.84.17,1.844.116h0l1.838.064h0v0h0V5.328h0L28.5,5.27h0l-1.445-.1h0l-1.443-.138h0l-1.439-.18h0l-1.431-.219h0l-1.425-.259h0l-1.415-.3h0l-1.409-.339h0l-1.4-.379h0l-1.389-.417h0L14.33,2.485h0l-1.365-.5h0l-.09.225-.255.618h0l-.381.936L11.76,4.939h0l-.545,1.329-.575,1.41-.577,1.41-.543,1.329h0L9.04,11.59l-.383.934-.253.62h0Z",
    transform: "translate(-8.312 -1.99)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29053",
    "data-name": "Path 29053",
    d: "M8.4,2.067Z",
    transform: "translate(9.557 13.374)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29054",
    "data-name": "Path 29054",
    d: "M8.392,2.066Z",
    transform: "translate(7.726 13.204)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29055",
    "data-name": "Path 29055",
    d: "M8.329,2.053Z",
    transform: "translate(-4.839 10.553)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29056",
    "data-name": "Path 29056",
    d: "M8.321,2.05Z",
    transform: "translate(-6.583 9.967)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29057",
    "data-name": "Path 29057",
    d: "M8.383,2.065Z",
    transform: "translate(5.903 12.981)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22518",
    "data-name": "Group 22518",
    transform: "translate(1595.648 357.703)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29058",
    "data-name": "Path 29058",
    d: "M8.433,5.328h0V17.611h0l1.85-.064h0l1.846-.116,1.84-.17,1.834-.225,1.824-.277h0l1.816-.329h0l1.806-.381h0l1.794-.433h0l1.78-.485h0l1.768-.535,1.752-.589,1.738-.64h-.012l-.09-.223h0l-.253-.62h0l-.383-.934h0l-.479-1.173-.543-1.329h0l-.577-1.41-.575-1.41-.543-1.329h0l-.481-1.171-.381-.936h0l-.254-.618-.09-.225h0l-1.365.5h0l-1.375.459h0l-1.389.417h0l-1.4.379h0l-1.409.339h0l-1.415.3h0l-1.425.259h0l-1.431.221h0l-1.44.178h0l-1.441.136h0l-1.448.1h0l-1.451.056Z",
    transform: "translate(-8.433 -1.99)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29059",
    "data-name": "Path 29059",
    d: "M8.533,2.05Z",
    transform: "translate(11.381 9.967)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29060",
    "data-name": "Path 29060",
    d: "M8.524,2.053Z",
    transform: "translate(9.637 10.553)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29061",
    "data-name": "Path 29061",
    d: "M8.47,2.065Z",
    transform: "translate(-1.099 12.981)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29062",
    "data-name": "Path 29062",
    d: "M8.461,2.066Z",
    transform: "translate(-2.924 13.204)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29063",
    "data-name": "Path 29063",
    d: "M8.452,2.067Z",
    transform: "translate(-4.755 13.374)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22519",
    "data-name": "Group 22519",
    transform: "translate(1615.148 346.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29064",
    "data-name": "Path 29064",
    d: "M8.531,11.778h0L8.623,12h0l.253.618.383.936.479,1.171h0l.543,1.331.577,1.408.575,1.41.543,1.329h0l.481,1.173.381.934.255.62.09.225h0l1.728-.784h0l1.7-.832,1.676-.88h0l1.65-.93h0l1.62-.978h0l1.59-1.025h0l1.56-1.073h0l1.528-1.117h0l1.494-1.163,1.459-1.207h0l1.425-1.251h0L32,10.623h0l-.171-.172h0l-.473-.471-.714-.714h0l-.894-.9L28.737,7.355h0L27.662,6.279,26.586,5.2,25.569,4.187l-.894-.894h0l-.714-.714-.473-.473-.17-.17h0L22.223,2.946h0L21.1,3.923h0l-1.151.944h0l-1.175.91h0l-1.2.876h0L16.349,7.5h0L15.1,8.3h0l-1.273.77h0l-1.293.734h0l-1.315.7h0l-1.335.658h0l-1.355.62Z",
    transform: "translate(-8.531 -1.936)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29065",
    "data-name": "Path 29065",
    d: "M8.626,2Z",
    transform: "translate(10.575 10.442)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29066",
    "data-name": "Path 29066",
    d: "M8.571,2.033Z",
    transform: "translate(-0.486 17.572)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29067",
    "data-name": "Path 29067",
    d: "M8.614,16.638h0l.17.17h0l.473.473L9.971,18h0l.9.894,1.014,1.017h0l1.077,1.079,1.076,1.077,1.015,1.017.894.9h0L17.3,25.335h0l1.293-1.39h0l1.251-1.424h0l1.207-1.462h0l1.163-1.494h0l1.119-1.526h0l1.07-1.56h0l1.027-1.59h0l.978-1.62h0l.93-1.648h0l.88-1.676h0l.834-1.7h0l.782-1.728h0V6.5h0l-.224-.09h0l-.618-.255-.936-.381h0L26.885,5.3l-1.329-.545h0l-1.409-.575h0L22.737,3.6h0l-1.329-.545-1.173-.479h0L19.3,2.2l-.62-.253h0l-.224-.092h0l-.622,1.355h0l-.659,1.335h0l-.7,1.315h0l-.734,1.293h0l-.77,1.271h0L14.171,9.67h0L13.329,10.9h0l-.874,1.2h0l-.91,1.175h0L10.6,14.42h0l-.976,1.123h0l-1.01,1.095Z",
    transform: "translate(1623.225 328.293)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22520",
    "data-name": "Group 22520",
    transform: "translate(1642.68 310.687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29068",
    "data-name": "Path 29068",
    d: "M8.668,18.752h0l.225.09.619.253h0l.934.383,1.173.479h0l1.329.543,1.409.577,1.409.575h0L17.1,22.2l1.171.479h0l.934.383h0l.844.345h0l.64-1.736h0l.587-1.754h0l.537-1.768h0l.485-1.782.433-1.795.381-1.8.329-1.817h0l.277-1.827h0l.225-1.833.17-1.839L24.227,3.6h0l.064-1.849h0v0h0v0h0l0,0h0v0h0v0H12l-.056,1.45h0l-.1,1.448h0L11.707,6.1h0l-.179,1.438h0l-.216,1.43h0L11.054,10.4v0l-.3,1.416h0l-.339,1.408h0l-.377,1.4h0L9.62,16.007h0l-.455,1.377h0l-.5,1.367Z",
    transform: "translate(-8.668 -1.755)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29069",
    "data-name": "Path 29069",
    d: "M8.745,1.774Z",
    transform: "translate(6.698 1.92)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29070",
    "data-name": "Path 29070",
    d: "M8.744,1.783Z",
    transform: "translate(6.528 3.749)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29071",
    "data-name": "Path 29071",
    d: "M8.74,1.81Z",
    transform: "translate(5.702 9.198)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29072",
    "data-name": "Path 29072",
    d: "M8.738,1.819Z",
    transform: "translate(5.323 10.993)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29073",
    "data-name": "Path 29073",
    d: "M8.736,1.828Z",
    transform: "translate(4.893 12.779)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22521",
    "data-name": "Group 22521",
    transform: "translate(1642.707 286.338)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29074",
    "data-name": "Path 29074",
    d: "M8.668,6.286h0l.5,1.365h0L9.618,9.03h0l.415,1.389h0l.377,1.4h0l.339,1.41h0l.3,1.418h0L11.3,16.07h0l.218,1.434h0l.179,1.438h0l.14,1.444h0l.1,1.446h0L12,23.282H24.281l-.064-1.851h0L24.1,19.585l-.17-1.841h0l-.225-1.833h0l-.277-1.825h0L23.1,12.271h0l-.381-1.8h0l-.433-1.795L21.8,6.891h0l-.537-1.768h0L20.676,3.37l-.629-1.736h-.01v0h0v0h0l-.214.086-.618.253h0l-.936.383L17.1,2.839h0l-1.329.543-1.409.577-1.409.575h0l-1.329.543-1.173.479-.934.383h0l-.619.253-.224.092Z",
    transform: "translate(-8.668 -1.634)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29075",
    "data-name": "Path 29075",
    d: "M8.728,1.643Z",
    transform: "translate(3.28 0.094)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29076",
    "data-name": "Path 29076",
    d: "M8.736,1.669Z",
    transform: "translate(4.882 5.369)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29077",
    "data-name": "Path 29077",
    d: "M8.745,1.723Z",
    transform: "translate(6.688 16.228)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29078",
    "data-name": "Path 29078",
    d: "M8.614,10.216h0l1.01,1.095h0l.978,1.123h0l.944,1.149h0l.91,1.175h0l.876,1.2h0l.842,1.223h0l.806,1.249h0l.77,1.271h0l.734,1.293h0l.7,1.315h0l.657,1.335h0L18.459,25h0l.222-.092.619-.253.934-.383h0l1.173-.479,1.329-.543h0l1.409-.577,1.409-.575,1.331-.543h0l1.171-.479h0l.936-.383.617-.253.225-.092h0l-.782-1.728h0l-.832-1.7h0L27.34,15.24h0l-.93-1.65h0l-.978-1.62h0l-1.024-1.59h0L23.335,8.822h0L22.216,7.294h0L21.054,5.8l-1.207-1.46h0L18.6,2.915h0L17.3,1.528h0l-.171.17-.473.473h0l-.714.714-.9.894h0L14.035,4.8,12.958,5.871,11.882,6.947h0L10.867,7.962h0l-.9.9-.714.714h0l-.473.473h0l-.171.17Z",
    transform: "translate(1623.225 263.518)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22523",
    "data-name": "Group 22523",
    transform: "translate(1595.678 245.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29085",
    "data-name": "Path 29085",
    d: "M8.433,1.429h0l.008,0h0V13.714h0l1.449.058h0l1.447.1h0l1.443.138h0l1.437.178h0l1.43.219h0l1.425.261h0l1.415.3h0L19.9,15.3h0l1.4.377h0l1.389.417h0l1.377.457h0l1.367.5h0l.09-.225.255-.62h0l.381-.934.481-1.173h0l.543-1.329.575-1.41h0l.577-1.408h0l.543-1.331.479-1.171h0l.383-.936.253-.618h0l.092-.225h0l-1.738-.64-1.752-.587-1.77-.537-1.782-.485h0l-1.794-.433h0L19.441,2.61h0l-1.816-.329h0L15.8,2h0l-1.834-.223h0l-1.838-.17-1.846-.118h0L8.443,1.429h-.01Z",
    transform: "translate(-8.433 -1.429)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29086",
    "data-name": "Path 29086",
    d: "M8.452,1.43Z",
    transform: "translate(-4.757 -1.248)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29087",
    "data-name": "Path 29087",
    d: "M8.515,1.442Z",
    transform: "translate(7.876 1.038)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29088",
    "data-name": "Path 29088",
    d: "M8.524,1.444Z",
    transform: "translate(9.637 1.573)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29089",
    "data-name": "Path 29089",
    d: "M8.533,1.447Z",
    transform: "translate(11.381 2.158)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22522",
    "data-name": "Group 22522",
    transform: "translate(1615.148 250.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29079",
    "data-name": "Path 29079",
    d: "M8.531,12.832h0l1.355.624h0l1.335.658v0l1.315.7h0l1.293.734h0l1.273.77h0l1.247.8h0l1.225.842h0l1.2.874h0l1.175.91h0l1.151.944h0l1.123.976h0l1.095,1.011h0l.17-.17.473-.473.714-.714h0l.894-.9,1.017-1.015,1.077-1.077,1.075-1.075h0l1.016-1.017.894-.894h0l.714-.714.473-.473h0l.171-.17h0L30.617,12.7h0l-1.425-1.251h0l-1.459-1.207L26.239,9.075h0L24.711,7.958h0l-1.56-1.073h0l-1.59-1.025h0l-1.62-.978h0l-1.65-.93h0L16.616,3.07l-1.7-.832h0l-1.728-.782h0l-.09.225-.255.618h0l-.381.936-.481,1.171h0l-.543,1.329-.575,1.41h0l-.577,1.41L9.737,9.883h0l-.479,1.173-.383.934-.253.62h0Z",
    transform: "translate(-8.531 -1.456)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29080",
    "data-name": "Path 29080",
    d: "M8.571,1.464Z",
    transform: "translate(-0.486 0.15)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29081",
    "data-name": "Path 29081",
    d: "M8.626,1.5Z",
    transform: "translate(10.575 7.283)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29916",
    "data-name": "Path 29916",
    d: "M8.169,53.736h50.4v0h0v0h0L22.934,89.384h0l.758.758h0L59.338,54.5h0l0,0h0v50.4h1.075V54.5h0v0h0L96.067,90.142h0l.768-.758h0L61.189,53.75h0v0h0v0h50.4V52.669h-50.4v0h0L96.835,17.024h0v-.01h0l-.768-.758h0L60.421,51.9h0V1.491H59.342V52.659h0v0H8.169Z",
    transform: "translate(1534.447 256.139)",
    fill: "#125d60",
    stroke: "#555",
    strokeWidth: 0,
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashedCircle);
export default __webpack_public_path__ + "static/media/dashed_circle.f1329d8135289be3ec50fe13396b65c5.svg";
export { ForwardRef as ReactComponent };